import store from '../store/index'

export const HEADERS = { headers: { 'Content-Type': 'application/json' } }
export let AUTH_HEADERS_FILE = function () {
    let headers = { 'Content-Type': 'application/json' }
    if (store.state.auth && store.state.auth.accessToken) {
        headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`
    }
    return { headers, timeout: 30000 }
}
export let AUTH_HEADERS = function () {
    let headers = { 'Content-Type': 'application/json' }
    if (store.state.auth && store.state.auth.accessToken) {
        headers['Authorization'] = `Bearer ${store.state.auth.accessToken}`
    }
    return { headers, timeout: 10000 }
}
